/**
 * File extension constants matching backend FileExtensionEnum
 */
export enum FileExtension {
  PDF = '.pdf',
  PNG = '.png',
  JPG = '.jpg',
  JPEG = '.jpeg',
  TIFF = '.tiff',
  BMP = '.bmp',
  GIF = '.gif',
  DOCX = '.docx',
  XLSX = '.xlsx',
  TXT = '.txt'
}

/**
 * Helper class to work with file extensions
 */
export class FileExtensionHelper {
  /**
   * Check if a URL or filename has a specific extension
   * @param url The URL or filename to check
   * @param extension The extension to check for (e.g., FileExtension.PDF)
   * @returns True if the URL has the specified extension
   */
  static hasExtension(url: string, extension: FileExtension): boolean {
    if (!url) {
      return false;
    }

    // Remove query parameters (like SAS tokens) before checking extension
    const urlWithoutQuery = url.split('?')[0];
    return urlWithoutQuery.toLowerCase().endsWith(extension.toLowerCase());
  }

  /**
   * Check if a URL or filename is a PDF
   * @param url The URL or filename to check
   * @returns True if it's a PDF file
   */
  static isPdf(url: string): boolean {
    return this.hasExtension(url, FileExtension.PDF);
  }

  /**
   * Get file extension from a URL or filename
   * @param url The URL or filename
   * @returns The file extension (lowercase, including the dot) or empty string if none found
   */
  static getExtension(url: string): string {
    if (!url) {
      return '';
    }

    // Remove query parameters
    const urlWithoutQuery = url.split('?')[0];
    
    // Get the last part after the last dot
    const lastDotIndex = urlWithoutQuery.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return '';
    }

    return urlWithoutQuery.substring(lastDotIndex).toLowerCase();
  }
}

